<template>
  <div :class="classes">
    <div class="alert__body">
      <slot></slot>
      {{ newText }}
    </div>
    <a v-if="withCloseBtn" @click="closeAlert()" class="alert__close-btn">
      <m4-icon icon="close-circle"></m4-icon>
    </a>
  </div>
</template>

<script>
export default {
  name: "M4Alert",
  data() {
    return {
      opened: true,
      newVariant: this.variant,
      newText: this.text
    };
  },
  props: {
    variant: {
      type: String
    },
    size: {
      type: String
    },
    borderRadius: {
      type: Boolean,
      default() {
        return true;
      }
    },
    isLight: {
      type: Boolean
    },
    isLighter: {
      type: Boolean
    },
    withCloseBtn: {
      type: Boolean
    },
    leftArrow: {
      type: Boolean
    },
    bottomArrow: {
      type: Boolean
    },
    topArrow: {
      type: Boolean
    },
    text: {
      type: String
    }
  },
  emits: ["closeAlert"],
  computed: {
    classes() {
      let classes = ["alert"];
      if (this.newVariant) {
        classes.push("alert--" + this.newVariant);
      }
      if (this.size) {
        classes.push("alert--" + this.size);
      }
      if (this.isLight) {
        classes.push("alert--light");
      }
      if (this.isLighter) {
        classes.push("alert--lighter");
      }
      if (this.borderRadius) {
        classes.push("alert--radius");
      }
      if (this.leftArrow) {
        classes.push("alert--left-arrow");
      }
      if (this.bottomArrow) {
        classes.push("alert--bottom-arrow");
      }
      if (this.topArrow) {
        classes.push("alert--top-arrow");
      }
      if (this.withCloseBtn) {
        classes.push("alert--with-close-btn");
      }
      if (this.opened === false) {
        classes.push("alert--closing");
      }
      return classes;
    }
  },
  methods: {
    setText(text) {
      this.newText = text;
    },
    setVariant(variant) {
      this.newVariant = variant;
    },
    closeAlert() {
      this.opened = false;
      this.$emit("closeAlert");
    }
  }
};
</script>
